<template>
  <a-menu-item :key="menuInfo.key" v-bind="$props" v-on="$listeners" :disabled="menuInfo.disabled">
    <router-link v-if="menuInfo.url" :to="menuInfo.url">
       <p><i v-if="menuInfo.icon" :class="[styles.icon, menuInfo.icon]"></i></p>
      <p :class="styles.title">{{ menuInfo.title }}</p>
    </router-link>
    <span v-if="!menuInfo.url" :to="menuInfo.url">
      <p><i v-if="menuInfo.icon" :class="[styles.icon, menuInfo.icon]"></i></p>
      <p :class="styles.title">{{ menuInfo.title }}</p>
    </span>
  </a-menu-item>
</template>

<script>
import { Menu } from 'ant-design-vue'

export default {
  name: 'SubMenu',
  props: {
    ...Menu.Item.props,
    menuInfo: Object,
    styles: Object,
  },
}
</script>
